<template>
    <div>
        <div class="campaign-option--title">
            Product Type
            <info-tooltip :text="tooltipContent"></info-tooltip>
        </div>

        <div v-if="!editing">
            <div v-for="loanPurpose in loanPurposesList" :key="loanPurpose.id" class="m-b-sm">
                <label class="c-clickable" :for="loanPurpose.id">
                    <input
                        type="radio"
                        name="loan_purposes"
                        class="c-clickable"
                        v-model="selected"
                        :value="loanPurpose"
                        :disabled="editing"
                        :id="loanPurpose.id">
                    <span class="p-l-md">{{ loanPurpose.label }}</span>
                </label>
                <div class="product-type-cd-term-select-container radio-buffer p-b-md p-t-md" v-if="certificateOfDepositSelected && isCertificateOfDeposit(loanPurpose)">
                    <slot></slot>
                </div>
            </div>
        </div>

        <div v-if="editing && certificateOfDepositSelected" class="product-type-cd-term-select-container p-b-md p-t-md">
            <slot></slot>
        </div>
    </div>
</template>

<script type="text/babel">
    export default {
        props: {
            value: Array,
            loanPurposesList: Array,
            editing: Boolean
        },
        data() {
            return {
                selected: null
            }
        },
        created() {
            this.setSelected();
        },
        watch: {
            value(value) {
                this.setSelected();
            },
            selected() {
                this.$emit('input', [this.selected]);
            }
        },
        computed: {
            certificateOfDepositSelected() {
                return this.selected && this.isCertificateOfDeposit(this.selected);
            },
            tooltipContent() {
                return this.editing ? 'Specify CD terms to target.' : 'Select a product that you wish to apply to this ad set. If CD is selected, you may specify<br>terms to target. Terms for which you do not have rates uploaded are notated as "no rates".';
            }
        },
        methods: {
            isCertificateOfDeposit(loanPurpose) {
                return loanPurpose.id === 'certificate of deposit';
            },
            setSelected() {
                this.selected = this.value.length > 0 ? this.value[0] : null;
            }
        }
    }
</script>
